import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Globals} from '../../global/globals';
import {Category} from '../../dtos/vocab/category/category';
import {CategoryNode} from '../../dtos/vocab/category/category-node';
import {CategoryPage} from '../../dtos/vocab/category/category-page';
import {VocabCategoryCreationDto} from "../../dtos/vocab/category/vocab-category-creation-dto";
import {VocabCategoryDetailDto} from "../../dtos/vocab/category/vocab-category-detail-dto";

@Injectable({
  providedIn: 'root'
})
export class CategoryService {

  categoryBaseUri: string = this.globals.backendUri + '/vocabulary/categories';

  constructor(private httpClient: HttpClient, private globals: Globals) {
  }

  /**
   * Loads specific category from the backend
   *
   * @param id of category to load
   */
  getCategoryByID(id: number): Observable<VocabCategoryDetailDto> {
    return this.httpClient.get<VocabCategoryDetailDto>(this.categoryBaseUri + '/' + id);
  }

  /**
   * Load all root categories including subcategories
   */
  getRootCategories(): Observable<any[]> {
    return this.httpClient.get<CategoryNode[]>(this.categoryBaseUri + '/roots');
  }

  searchCategories(params: HttpParams): Observable<CategoryPage> {
    return this.httpClient.get<CategoryPage>(this.categoryBaseUri, {params});
  }

  deleteCategory(id: number): Observable<any> { // TODO check with Max
    return this.httpClient.delete<any>(this.categoryBaseUri + '/' + id);
  }

  updateCategory(category: VocabCategoryCreationDto) {
    return this.httpClient.put<Category>(this.categoryBaseUri + '/' + category.id, category);

  }

  createCategory(category: VocabCategoryCreationDto) {
    return this.httpClient.post<Category>(this.categoryBaseUri, category);
  }
}
